// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorBoundary_root__sQ1dV","error":"ErrorBoundary_error__hwGAY","rootExpanded":"ErrorBoundary_rootExpanded__XcA3A"};